import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { deleteFormDefinition, publishFormDefinition, duplicateFormDefinition } from '../../../services/clinicPortalServices/formDefinitionService';
import toastr from 'toastr';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formId: props.data._id
        };
    }

    handleEdit = () => {
        if (this.props.context.componentParent.handleEdit) {
            this.props.context.componentParent.handleEdit(this.props.data);
        }
    };

    handlePublish = () => {
        publishFormDefinition({ _id: this.state.formId }).then(() => {
            toastr.success('Form published successfully');
            this.props.context.componentParent.loadGridData();
        });
    };

    handleDuplicate = () => {
        duplicateFormDefinition({ _id: this.state.formId }).then(() => {
            toastr.success('Form duplicated successfully');
            this.props.context.componentParent.loadGridData();
        });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this form definition!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteFormDefinition({ _id: this.state.formId }).then(() => {
                    toastr.success('Form deleted successfully');
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Form
        </Tooltip>
    );

    renderTooltipPublish = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Publish Form
        </Tooltip>
    );

    renderTooltipDuplicate = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Duplicate Form
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Form
        </Tooltip>
    );

    render() {
        const isDraft = this.props.data.status === 'draft';

        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleEdit} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                {isDraft && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipPublish}>
                        <button onClick={this.handlePublish} className="edit-order-btn" style={{ color: 'green' }}>
                            <i className="fas fa-check-circle"></i>
                        </button>
                    </OverlayTrigger>
                )}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDuplicate}>
                    <button onClick={this.handleDuplicate} className="edit-order-btn" style={{ color: '#17a2b8' }}>
                        <i className="fas fa-copy"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
            </div>
        );
    }
}
